import React from "react";
import "./ReportCard.scss";
import Tooltip from "../Tooltip";

import ReportIcon from "@/assets/icons/custom_questions_report.svg";
import SuccessIcon from "@/assets/icons/icon_success.svg";
import AlertIcon from "@/assets/icons/alert-circle.png";
import ClipLoader from "react-spinners/ClipLoader";

const ReportCard = ({ report_title, report_status, report_status_message, onClick }) => {

    const renderStatusIcon = () => {
        switch (report_status) {
            case "processing":
                return <ClipLoader color="#00BFFF" size={20} />;
            case "success":
                return <img src={SuccessIcon} alt="Success" className="action-icon" />;
            case "failure":
                return <img src={AlertIcon} alt="Failure" className="action-icon" />;
            default:
                return null;
        }
    }
    const statusLabel = report_status_message || (report_status === "success" ? "Ready" : "Processing");
    const subtitle =
        report_status === "success"
            ? (report_status_message || "Tap to view the finished report")
            : (report_status_message || "Hang tight — building your report");

    return (
        <div className="report-card" onClick={onClick}>
            <div className="left-section">
                <div className="icon-wrapper">
                    <img src={ReportIcon} alt="Icon" className="icon" />
                </div>
                <div className="text-content">
                    <div className="title">{report_title}</div>
                    <div
                        className="description"
                    >
                        {subtitle}
                    </div>
                </div>
            </div>
            <div className="right-section">
                <Tooltip content={statusLabel} placement="top" arrow={true} variant="light">
                    <div className="status-icon-wrapper">
                        {renderStatusIcon()}
                    </div>
                </Tooltip>
            </div>
        </div>
    );
};

export default ReportCard;
